module.exports = __webpack_public_path__ + "static/white_bg1-1d809685689c46f0868e7763921d79c6.png";